module.exports = __webpack_public_path__ + "static/media/floria shot 03.fe491baf.webp";